// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import "./raiseInvoiceFooter.scss";
// project file imports(UI components) ⇒
import PrimaryButton from "../../common/Buttons/PrimaryButton";

const RaiseInvoiceFooter = (props) => {
  const { totalFees, isPendingView, disableSubmit, handleSubmit } = props;

  // create UI ⇒
  const raiseInvoiceFooterUI = () => {
    return (
      <div className="raise-invoice-footer-container">
        <div className="rifc-wrapper">
          <div
            className={`raise-invoice-footer-content ${
              isPendingView ? "rif-hw" : "rif-fw"
            }`}
          >
            <div className="raise-invoice-footer-title">
              Total Fee : <span>₹</span> {totalFees}
            </div>
            <div className="raise-invoice-footer-button">
              <PrimaryButton
                title="Submit"
                disabled={disableSubmit}
                handleButtonClick={handleSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  return <div>{raiseInvoiceFooterUI()}</div>;
};

//export
export default RaiseInvoiceFooter;
